import React from 'react'

const OutOfStock = () => {
  return (
    <div>OutOfStock</div>
  )
}

export default OutOfStock